import type { TLayoutsListParams } from 'app/queries/layouts/layoutsKeys';
import { DEFAULT_LAYOUT_SORT } from './parseLayoutSortValue';

export const LAYOUT_PAGE_SIZE = 10;
export const LAYOUTS_STALE_TIME_MS = 30_000;

export const DEFAULT_LAYOUTS_LIST_PARAMS: TLayoutsListParams = {
  page: 1,
  pageSize: LAYOUT_PAGE_SIZE,
  search: '',
  ...DEFAULT_LAYOUT_SORT,
};
